import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { X, Clock } from 'lucide-react'
import { openCheckout } from '@/hooks/useBilling'

interface TrialBannerProps {
  orgId: string
  orgSlug: string
  daysRemaining: number | null
}

export function TrialBanner({ orgId, orgSlug, daysRemaining }: TrialBannerProps) {
  const storageKey = `trial-banner-dismissed-${orgId}`
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(storageKey) === 'true'
  })

  useEffect(() => {
    if (dismissed) localStorage.setItem(storageKey, 'true')
  }, [dismissed, storageKey])

  if (dismissed) return null

  const dayLabel =
    daysRemaining === null
      ? ''
      : daysRemaining === 0
      ? 'Your trial expires today.'
      : daysRemaining === 1
      ? '1 day left in your trial.'
      : `${daysRemaining} days left in your trial.`

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-blue-50 border-b border-blue-200 text-blue-900 text-sm">
      <Clock className="h-4 w-4 text-blue-600 shrink-0" />
      <span className="flex-1">
        {dayLabel} Upgrade to keep full access after your trial ends.
      </span>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          onClick={() => openCheckout(orgId, orgSlug)}
        >
          Upgrade — $29/mo
        </Button>
        <button
          onClick={() => setDismissed(true)}
          className="text-blue-600 hover:text-blue-800"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
